"use client";

import { useGoogleLogin } from "@react-oauth/google";
import Cookies from "js-cookie";
import { FaGoogle } from "react-icons/fa";

const GoogleLoginButton = ({
  mode = "login",
  onUserData,
}) => {

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {

      // ✅ FETCH GOOGLE USER DATA
      const userRes = await fetch(
        "https://www.googleapis.com/oauth2/v1/userinfo?alt=json",
        {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        }
      );

      const userData = await userRes.json();

      // ✅ CONTACT PAGE MODE
      if (mode === "contact") {

        onUserData?.({
          name: userData.name || "",
          email: userData.email || "",
          mobile: "",
        });

        return;
      }

      // ✅ NORMAL LOGIN FLOW
      const res = await fetch("/app/api/auth/google-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: tokenResponse.access_token,
        }),
      });

      let qr = Cookies.get("current_qr");

      if (res.ok) {
        if (qr) {
          window.location.href = `/app/dashboard/add-item`;
        } else {
          window.location.href = "/app/dashboard";
        }
      }
    },

    onError: () => console.error("Google login failed"),

    flow: "implicit",
  });

  return (
    <button
      onClick={() => login()}
      className="d-flex align-items-center justify-content-center gap-2 border rounded bg-white shadow-sm"
      style={{
        height: "33px",
        fontSize: "14px",
        fontWeight: 400,
        borderColor: "#dadce0",
        width: "100%",
        color: "#3c4043",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded"
        style={{
          backgroundColor: "white",
          width: "20px",
          height: "15px",
        }}
      >
        <FaGoogle size={18} color="#561037" />
      </div>

      <span>Sign in with Google</span>
    </button>
  );
};

export default GoogleLoginButton;